import React, { useEffect, useState } from "react";
import { Modal, InputNumber, message, ConfigProvider, Select } from "antd";
import { FaUser } from "react-icons/fa";
import "./passenger-modal.scss";
import "./flights-search-tabs.scss";

const PassengerModal = ({
  open,
  onCancel,
  passengerParams,
  setPassengerParams,
}) => {
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);
  const [cabin, setCabin] = useState("Economy");

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    setAdults(passengerParams.adults);
    setChildren(passengerParams.children);
    setInfants(passengerParams.infants);
    setCabin(passengerParams.cabin);
  }, [passengerParams]);

  function onConfirm() {
    setPassengerParams({
      adults: adults,
      children: children,
      infants: infants,
      cabin: cabin
    });

    onCancel();
  }

  const messageSuccess = (content) => {
    messageApi.open({
      type: 'success',
      content: content,
    });
  };

  const messageError = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };

  const validateCounts = ({ adults, children, infants, showMessage = true }) => {
    if (adults < 1) {
      if (showMessage) messageApi.error('At least 1 adult is required.');
      return false;
    }
  
    const total = adults + children + infants;
    if (total > 9) {
      if (showMessage) messageApi.error('A maximum of 9 passengers is allowed.');
      return false;
    }
  
    if (infants > adults) {
      if (showMessage) messageApi.error('Infants cannot exceed adults.');
      return false;
    }
  
    if (children < 0 || infants < 0) {
      return false;
    }
  
    return true;
  };

  const increment = (type) => {
    let newAdults = adults;
    let newChildren = children;
    let newInfants = infants;
  
    if (type === 'adults') newAdults += 1;
    if (type === 'children') newChildren += 1;
    if (type === 'infants') newInfants += 1;
  
    if (!validateCounts({ adults: newAdults, children: newChildren, infants: newInfants })) return;
  
    if (type === 'adults') setAdults(newAdults);
    if (type === 'children') setChildren(newChildren);
    if (type === 'infants') setInfants(newInfants);
  };
  
  const decrement = (type) => {
    let newAdults = adults;
    let newChildren = children;
    let newInfants = infants;
  
    if (type === 'adults') newAdults -= 1;
    if (type === 'children') newChildren -= 1;
    if (type === 'infants') newInfants -= 1;
  
    if (!validateCounts({ adults: newAdults, children: newChildren, infants: newInfants })) return;
  
    if (type === 'adults') setAdults(newAdults);
    if (type === 'children') setChildren(newChildren);
    if (type === 'infants') setInfants(newInfants);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      maskClosable={false}
      keyboard={false}
      className="passenger-modal-wrapper"
      width={420}
      title={
        <div className="modal-title-custom">
          <FaUser /> {adults} Adult{adults > 1 ? "s" : ""}, Economy
        </div>
      }
    >
      <div className="passenger-modal">
        {contextHolder}

        <h6 className="instruction">
          Please select the exact number of passengers to view the best prices
        </h6>

        {/* Adults */}
        <div className="passenger-row">
          <div>
            <strong>Adults</strong>
            <br />
            <small>12+ years old</small>
          </div>
          <div className="quantity-box">
            <button
              type="button"
              className="qty-btn"
              onClick={() => decrement("adults")}
            >
              -
            </button>
            <span className="qty-count">{adults}</span>
            <button
              type="button"
              className="qty-btn"
              onClick={() => increment("adults")}
            >
              +
            </button>

            {/* <InputNumber
              mode="spinner"
              min={1}
              max={9}
              value={adults}
              onChange={(value) => setAdults(value)}
              style={{ width: 150 }}
            /> */}
          </div>
        </div>

        {/* Children */}
        <div className="passenger-row">
          <div>
            <strong>Children</strong>
            <br />
            <small>2-11 years old</small>
          </div>
          <div className="quantity-box">
            <button
              type="button"
              className="qty-btn"
              onClick={() => decrement("children")}
            >
              -
            </button>
            <span className="qty-count">{children}</span>
            <button
              type="button"
              className="qty-btn"
              onClick={() => increment("children")}
            >
              +
            </button>
          </div>
        </div>

        {/* Infants */}
        <div className="passenger-row">
          <div>
            <strong>Infants on lap</strong>
            <br />
            <small>Under 2 years old</small>
          </div>
          <div className="quantity-box">
            <button
              type="button"
              className="qty-btn"
              onClick={() => decrement("infants")}
            >
              -
            </button>
            <span className="qty-count">{infants}</span>
            <button
              type="button"
              className="qty-btn"
              onClick={() => increment("infants")}
            >
              +
            </button>
          </div>
        </div>

        <div className="flights-tab-select">
          {/* <select value={cabin} onChange={(e) => setCabin(e.target.value)}>
            <option>Economy</option>
            <option>Premium Economy</option>
            <option>Business</option>
            <option>First</option>
          </select> */}

          <ConfigProvider
            theme={{
              components: {
                Select: {
                  activeBorderColor: "#d9d9d9",
                  hoverBorderColor: "#d9d9d9",
                  optionSelectedBg: "#f5f5f5"
                },
              },
              token: {
                controlHeight: 40,
              },
            }}
          >
            <Select
              style={{ width: "100%" }}
              value={cabin}
              onChange={(value) => setCabin(value)}
              options={[
                { value: 'Economy', label: 'Economy' },
                { value: 'Premium Economy', label: 'Premium Economy' },
                { value: 'Business', label: 'Business' },
                { value: 'First', label: 'First'},
              ]}
            />
          </ConfigProvider>
        </div>

        <div className="col-12 confirm-btn-wrapper">
          <div className="col-xl-3">
            <button type="button" className="confirm-btn" onClick={onConfirm}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PassengerModal;
